export default {
  closeButton: {
    position: 'absolute',
    right: 0,
    color: '#000000'
  }
};
